export default __webpack_public_path__ + "static/media/27popup.7b7f3d9a.jpg";